const LineTypes = {
  bus: "bus",
  place: "place",
};

export default LineTypes;
